/**
 * Datums-Autovervollständigung für Diäten (2026-06-10, Thomas) — analog zur
 * Zeit-Logik in timeFormat.ts: "160326" → "16.03.2026".
 *
 * Mit `cardYear` (aus expense.month "YYYY-MM") werden auch jahr-lose
 * Eingaben vervollständigt: "16.3" / "1603" → "16.03.2026". Das kann nur
 * die UI leisten — der OCR-Normalizer (paddle_vl._normalize_date_value)
 * kennt den Karten-Monat nicht und lässt jahr-lose Werte unverändert.
 */
export function formatDateInput(input: string, cardYear?: string | null): string {
  const s = input.trim().replace(/\s+/g, "");
  if (!s) return input;

  const build = (d: number, mo: number, y: number): string | null => {
    if (y < 100) y += 2000;
    if (d >= 1 && d <= 31 && mo >= 1 && mo <= 12 && y >= 2000 && y <= 2099) {
      return `${String(d).padStart(2, "0")}.${String(mo).padStart(2, "0")}.${y}`;
    }
    return null;
  };

  // Gepunktet mit Jahr: 16.3.26 / 16.03.2026 (optionaler Schlusspunkt)
  let m = /^(\d{1,2})\.(\d{1,2})\.(\d{2}|\d{4})\.?$/.exec(s);
  if (m) return build(+m[1]!, +m[2]!, +m[3]!) ?? input;

  // Gepunktet OHNE Jahr: 16.3 / 16.03. → Jahr vom Karten-Monat
  m = /^(\d{1,2})\.(\d{1,2})\.?$/.exec(s);
  if (m && cardYear && /^\d{4}$/.test(cardYear)) {
    return build(+m[1]!, +m[2]!, +cardYear) ?? input;
  }

  // Kompakt: 1603 (DDMM, Jahr von der Karte) / 160326 / 16032026
  if (/^\d{4}$/.test(s) && cardYear && /^\d{4}$/.test(cardYear)) {
    return build(+s.slice(0, 2), +s.slice(2, 4), +cardYear) ?? input;
  }
  if (/^\d{6}$/.test(s)) {
    return build(+s.slice(0, 2), +s.slice(2, 4), +s.slice(4)) ?? input;
  }
  if (/^\d{8}$/.test(s)) {
    return build(+s.slice(0, 2), +s.slice(2, 4), +s.slice(4)) ?? input;
  }
  return input;
}
